/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_DeliveryInputs */

const en_svchip_delivery = /** @type {(inputs: Svchip_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery`)
};

const ar_svchip_delivery = /** @type {(inputs: Svchip_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التسليم`)
};

const bn_svchip_delivery = /** @type {(inputs: Svchip_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডেলিভারি`)
};

const de_svchip_delivery = /** @type {(inputs: Svchip_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieferung`)
};

const es_svchip_delivery = /** @type {(inputs: Svchip_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega`)
};

const fr_svchip_delivery = /** @type {(inputs: Svchip_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livraison`)
};

const pt_svchip_delivery = /** @type {(inputs: Svchip_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega`)
};

const zh_svchip_delivery = /** @type {(inputs: Svchip_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`交付`)
};

const tr_svchip_delivery = /** @type {(inputs: Svchip_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teslimat`)
};

const ru_svchip_delivery = /** @type {(inputs: Svchip_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доставка`)
};

const pl_svchip_delivery = /** @type {(inputs: Svchip_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostawa`)
};

/**
* | output |
* | --- |
* | "Delivery" |
*
* @param {Svchip_DeliveryInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_delivery = /** @type {((inputs?: Svchip_DeliveryInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_DeliveryInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_delivery(inputs)
	if (locale === "bn") return bn_svchip_delivery(inputs)
	if (locale === "de") return de_svchip_delivery(inputs)
	if (locale === "es") return es_svchip_delivery(inputs)
	if (locale === "fr") return fr_svchip_delivery(inputs)
	if (locale === "pt") return pt_svchip_delivery(inputs)
	if (locale === "zh") return zh_svchip_delivery(inputs)
	if (locale === "tr") return tr_svchip_delivery(inputs)
	if (locale === "ru") return ru_svchip_delivery(inputs)
	if (locale === "pl") return pl_svchip_delivery(inputs)
	return en_svchip_delivery(inputs)
});